<template>
  <v-timeline-item right icon="cached" fill-dot color="green">
    <span slot="opposite">⚀ ⚁ ⚂ ⚃ ⚄ ⚅</span>
    <span>{{data.Result}}</span>
  </v-timeline-item>
</template>

<script>
export default {
  name: 'Roll',
  props: {
    data: Object,
  }
}
</script>
